import { DURATION_UNIT, LARGE_DURATION_UNITS } from '@constants'

const DURATION_UNIT_TO_SECONDS: Record<DURATION_UNIT, number> = {
  [DURATION_UNIT.MILLISECONDS]: 1 / 1000,
  [DURATION_UNIT.SECONDS]: 1,
  [DURATION_UNIT.MINUTES]: 60,
  [DURATION_UNIT.HOURS]: 3600,
  [DURATION_UNIT.DAYS]: 86400,
  [DURATION_UNIT.WEEKS]: 604800,
  [DURATION_UNIT.MONTHS]: 2592000,
  [DURATION_UNIT.YEARS]: 31536000,
}

export const convertToSeconds = (value: number, unit?: DURATION_UNIT | null): number => {
  const multiplier = DURATION_UNIT_TO_SECONDS[unit ?? DURATION_UNIT.SECONDS]

  return value * multiplier
}

export const convertFromSeconds = (seconds: number, unit?: DURATION_UNIT | null): number => {
  const multiplier = DURATION_UNIT_TO_SECONDS[unit ?? DURATION_UNIT.SECONDS]

  return seconds / multiplier
}

export const isLargeDurationUnit = (unit?: DURATION_UNIT | null): boolean => {
  if (!unit) return false

  return LARGE_DURATION_UNITS.includes(unit)
}
